import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {PipeModule} from "../../pipe/pipe.module";

@Component({
  selector: 'fb-product-description',
  standalone: true,
	imports: [CommonModule, PipeModule],
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss']
})
export class ProductDescriptionComponent {

	@Input()
	public product: Product = {} as Product;

	public prepareUrl(name: string): string {
		return name.replace(/\s+/g, '-').toLowerCase();
	}

	public getSubCategoryUrl(product: Product): string {
		if (product.productGroup === 'finished') {
			return `/products/finished?category=${this.prepareUrl(product.category.name)}&${this.prepareUrl(product.segment.name)}=${this.prepareUrl(product.subCategory.name)}`;
		}
		else if (product.category.name.toLowerCase() === 'swatchkit') {
			return `/products/fabric?category=${this.prepareUrl(product.category.name)}&${this.prepareUrl(product.segment.name)}=${this.prepareUrl(product.subCategory.name)}`;
		}
		else {
			return `/products/fabric?${this.prepareUrl(product.segment.name)}=${this.prepareUrl(product.subCategory.name)}`;
		}
	}
}
